import React from "react";
import { Box, Typography, Grid, Container } from "@mui/material";

import dynamicStyle from "./styles";

const PageNotFound = () => {
  const classes = dynamicStyle();
  return (
    <Box className={classes.box}>
      <Container maxWidth="md">
        <Grid container spacing={2}>
          <Grid xs={6}>
            <Typography variant="h1">404</Typography>
            <Typography variant="h6">
              The page you’re looking for doesn’t exist.
            </Typography>
          </Grid>
          <Grid xs={6}>
            <img
              src="https://cdn.pixabay.com/photo/2017/03/09/12/31/error-2129569__340.jpg"
              alt=""
              width={500}
              height={250}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default PageNotFound;
